import  { useEffect, useState } from "react";
import {  Button,  Form} from "antd";
import { doGet } from "../../../../API/apis";
import { CSVLink } from "react-csv";
import {
  formatDate,
  formatTime,
} from "../../../../utils/DateFormat";
import { useNavigate, useOutletContext } from "react-router-dom";
import Notification from "../../../../components/Notification/Notification";
import FormatDateTime from "../../../../components/FormatDate/FormatDateTime";
import CustomTable from "../../../../components/CustomTable/CustomTable";
import DateRangePickerCard from "../../../../components/GlobalComponents/DateRangePickerCard";
import { DetailCard, fullName } from "../../../../components/GlobalComponents/GlobalComponents";
import { AppointmentStatus } from "../../../../components/GlobalComponents/StatusLabels";
import Title from "../../../../components/Title/Title";


const AppointmentReports = () => {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);
  const [appointments, setAppointments] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [searchClicked, setSearchClicked] = useState(false);
  const [officeDateFormat, officeTimeFormat, officeTimezone] =
    useOutletContext();

  const transformAppointmentsForCSV = (appointments) => {
    if (!appointments) {
      return [];
    }

    return appointments.map((appointment) => ({
      "Patient MRN": appointment?.patient_MRN,
      "Patient Name": `${appointment?.first_name} ${appointment?.last_name}`,
      Date: formatDate(
        appointment.appointment_date,
        officeDateFormat,
        officeTimezone
      ),
      Time: formatTime(
        appointment.appointment_date,
        officeTimeFormat,
        officeTimezone
      ),
      Duration: `${appointment.duration} minutes`,
      Service: appointment.service,
      "Appointment With": appointment.appointment_with,
      "Visit Reason": appointment.visit_reason,
      Status: appointment.current_status,
      "Created By": appointment.created_by,
    }));
  };

  const coloumn = [

    {
      key: 2,
      title: "Patient Name",
      ellipsis: true,
      align: 'center',
      dataIndex: "full_name",
      searchable:true,

      render: (text, record) => {
  
        if (record?.patient_id) {
          return (
            <Button
              type="link"
              onClick={() => {
                navigate(`/main/charts/patient/${record?.patient_id}/`);
              }}
              className="text-[#1890ff]"
              title={`${record?.patient_MRN}`}
            >
              {fullName(record)}
            </Button>
          );
        } else {
          return (
            <span title={`${record?.patient_MRN}`}>
              {record?.first_name} {record?.last_name}
            </span>
          );
        }
      },
    },
    {
      key: 2,
      title: "Date",
      align: "center",
      dataIndex: "appointment_date",
      render: (text) => (
        <FormatDateTime date={text} type="datetime"/>
      ),
    },
    {
      key: 3,
      title: "Duration",
      align: "center",
      dataIndex: "duration",
      render: (text) => <span>{text} minutes</span>,
    },
    {
      key: 4,
      title: "Service",
      align: "center",
      dataIndex: "service",
      searchable:true,
    },
    {
      key: 5,
      title: "Appointment With",
      align: "center",
      dataIndex: "appointment_with",
      searchable:true,
    },
    {
      key: 7,
      title: "Visit Reason",
      align: "center",
      dataIndex: "visit_reason",
    },
    {
      key: 8,
      title: "Status",
      align: "center",
      ellipsis: true,
      dataIndex: "current_status", 
      render: (text) => <AppointmentStatus status={text} />
    },
    {
      key: 9,
      title: "Created By",
      align: "center",
      searchable:true,
      dataIndex: "created_by",
      render: (text) => <span>{text || "Not specified"}</span>,
    }
  ];

  const handleDateChange = (dates) => {
    setSelectedDateRange(dates);
  };

  const handleSearch = () => {
    if (selectedDateRange && selectedDateRange.length === 2) {
      setSearchClicked(true);
      getAppointments();
    } else {
      Notification.warning("Please select a date range");
    }
  };

  const getAppointments = async () => {
    setLoading(true);
    try {
      if (selectedDateRange && selectedDateRange.length === 2) {
        const startDate = selectedDateRange[0].format("YYYY-MM-DD");
        const endDate = selectedDateRange[1].format("YYYY-MM-DD");

        const response = await doGet(
          `/reports/appointments/?start_date=${startDate}&end_date=${endDate}`
        );
        if (response.status === 200) {
          const sortedAppointments = response.data.sort((a, b) => {
          return new Date(b.appointment_date) - new Date(a.appointment_date);
        });
          setAppointments(sortedAppointments); 
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleReset=()=>{
    setAppointments([])
    form.resetFields()
  }

  useEffect(() => {
    if (searchClicked) {
      getAppointments();
      setSearchClicked(false);
    }
  }, [searchClicked]);

  return (
      <DetailCard title="Appointments Report">
      <DateRangePickerCard
        onDateChange={handleDateChange}
        onSearch={handleSearch}
        onReset={handleReset}
      />
        <div className="flex justify-between items-center mb-2">
          <Title title="Search Results" />
          {appointments?.length > 0 && (
            <Button className="mr-2" type="primary">
              <CSVLink
                data={transformAppointmentsForCSV(appointments)}
                filename={"Appointment_reports.csv"}
                className="csv-link"
              >
                Download Report
              </CSVLink>
            </Button>
          )}
        </div>
        <CustomTable
          loading={loading}
          columns={coloumn}
          dataSource={appointments}
          key="appointments_report"
        />
      </DetailCard>
  );
};

export default AppointmentReports;
